import React from 'react';
import { Row, Input } from 'antd';
import { I18n } from '@aws-amplify/core';

import { FormWrapper } from '../components';
import { useSectionActionPlan } from '../context';

export function TaskTitle() {
	const { form_field_name } = useSectionActionPlan();
	return (
		<Row>
			<FormWrapper name={[...form_field_name, 'task', 'title']}>
				<Input.TextArea showCount rows={1} maxLength={240} placeholder={I18n.get('Add a new task')} />
			</FormWrapper>
		</Row>
	);
}
